import React, { useEffect } from "react";
import { View } from "react-native";

import { styles } from "./styles";
import { DescriptionHeading } from "components/description-heading";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "state/modules/questionnaires/actions";
import * as selectors from "screens/question/selectors";
import { getSurveyBackground } from "screens/question/selectors";
import Linkify from "components/linkify";
import { fillPlaceholders } from "state/modules/survey/selectors";

export const DescriptionQuestion = props => {
  const { question, lang } = props;

  const dispatch = useDispatch();
  const questionnaire = useSelector(selectors.getSurveyQuestionnaire);
  const state = useSelector(state => state);

  const headingKey = useSelector(selectors.getHeadingKey);
  const text = useSelector(state => fillPlaceholders(question[lang], state));
  const heading = useSelector(state =>
    fillPlaceholders(question[headingKey], state),
  );
  useEffect(() => {
    if (question.background_image) {
      dispatch(
        actions.setSurveyBackground(
          question.background_image,
          questionnaire.id,
        ),
      );
    }

    return () => {
      const background = getSurveyBackground(questionnaire, state);
      dispatch(actions.setSurveyBackground(background, questionnaire.id));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.contentContainer}>
        <DescriptionHeading heading={heading || ""} style={styles.heading} />
        <Linkify>{text}</Linkify>
      </View>
    </View>
  );
};
